import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Carousel from "nuka-carousel";
import { Link } from "react-router-dom";

class OpdClinicSoftware extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false, // Modal visibility state

      fname: "",
      lname: "",
      email: "",
      subject: "Demo for OPD + Clinic Management Software",
      message: "",
      loader: false,
    };
  }

  // Method to handle opening the modal
  // ===================================
  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, fname: "",
      lname: "",
      email: "", });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // =====================
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loader: true });
    const { fname, lname, email, subject, message } = this.state;
    try {
      const response = await fetch(
        "https://myhrms.anantayitsolutions.com/WebInquiry/AddWebInquiryDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: fname,
            lastName: lname,
            email: email,
            subject: subject,
            remarks: message,
          }),
        }
      );

      if (response.ok) {
        alert(" information submitted successfully!");
        const data = await response.json();
        console.log(data);
        this.closeModal();
      } else {
        alert("There was an error submitting the form.");
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      alert("There was an error submitting the form.");
      console.error(error);
    }

    this.setState({
      fname: "",
      lname: "",
      email: "",
      subject: "",
      message: "",
      loader: false,
    });
  };
  render() {
    const { isModalOpen, fname, lname, email, subject, message } = this.state;
    return (
      <>
        <section className="Portfolios-odd">
          <div className="container">
            <div className="section-title text-center" data-aos="fade-up">
              <h2 className="text-light">OPD+ Clinic Management Software</h2>
              {/* <p className="lead text-light mt-3">
      An all-in-one clinic management system designed to streamline your clinic operations.
    </p> */}
            </div>

            <div className="row text-light">
              {/* <!-- Left Section (Details) --> */}
              <div className="col-12 col-md-6">
                <div className="work-content pr-md-5">
                  <h4
                    style={{
                      // fontWeight: "600",
                      fontSize: "25px",
                      color: "#f39c12",
                    }}
                  >
                    OPD+ Clinic Management Software
                  </h4>
                  <div className="pdis mt-4">
                    {/* <h5 className="text-light">Details</h5> */}
                    <span>
                      OPD+ is clinic management software used by consulting
                      doctors, dispensary clinic, medical practitioner doctors.
                      OPD+ clinic software is developed and managed by Arcis
                      Info from Ahmedabad, Gujarat, India. We have more than
                      400+ clinics and hospitals client base all over India and
                      abroad. Our customers are using the OPD + since 2010 and
                      they have well managed patient records without any much
                      trouble.
                    </span>
                  </div>
                </div>
                {/* <Link to="/Contact" style={{ textDecoration: "none" }}> */}
                <button
                  onClick={this.openModal}
                  className="mt-5"
                  style={{
                    padding: "14px 28px",
                    color: "white",
                    border: "none",
                    borderRadius: "50px",
                    fontSize: "15px",
                    fontWeight: "bold",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    width: "auto",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "orange",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "darkorange";
                    e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "orange";
                    e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
                  }}
                >
                  BOOK YOUR FREE DEMO
                </button>

                {/* Modal */}

                {/* </Link> */}
                <div className="d-flex mt-3">
                  <FontAwesomeIcon
                    // icon={faPhoneSquare   }
                    icon={faPhone}
                    style={{ marginRight: "8px", marginTop: "8px", order: 1 }} // Icon on the left
                  />
                  <span
                    // to="tel:+919712312188"
                    style={{ order: 2, color: "white" }}
                  >
                    +91 97123 12188
                  </span>
                </div>
                <div className="mt-3 md-3">
                  <ul>
                    <div>
                      <input type="checkbox" checked />
                      <label className="ms-2">
                        Use Trail Version for 30 days before taking any
                        decision.
                      </label>
                    </div>

                    <div>
                      <input type="checkbox" id="customization" checked />
                      <label className="ms-2" htmlFor="customization">
                        We do customization as per clients need and requirement.
                      </label>
                    </div>
                    <div>
                      <input type="checkbox" id="support" checked />
                      <label className="ms-2" htmlFor="support">
                        1 Year Free Online, Telephonic, Chat Support.
                      </label>
                    </div>
                    <div>
                      <input type="checkbox" id="installation" checked />
                      <label className="ms-2" htmlFor="installation">
                        No extra cost for Installation and Training.
                      </label>
                    </div>
                  </ul>
                </div>
              </div>

              {/* <!-- Right Section (Features) --> */}
              <div className="col-12 col-md-6">
                <h5
                  className="ms-3 "
                  style={{
                    fontWeight: "600",
                    fontSize: "20px",
                    color: "#f39c12",
                  }}
                >
                  Features
                </h5>
                <ul>
                  <li>Appointment Management</li>
                  <li>Patient Registration with photo</li>
                  <li>
                    OPD Case Management with complaints, history, investigation,
                    provisional diagnosis, findings
                  </li>
                  <li>Get Patient Case History on single click</li>
                  <li>
                    OPD Prescription (with regional language support with
                    patient drug allergy alert)
                  </li>
                  <li>Prescription Templates Facility</li>
                  <li>Receipt </li>
                  <li>Patient Account Management</li>
                  <li>Family Account Management</li>
                  <li>Vaccine Schedule Management</li>
                  <li>Medicine Purchase </li>
                  <li>Medicine Current Stock </li>
                  <li>Expense Management </li>
                  <li>Patient Gallery for Documents and Videos</li>
                  <li>
                    Certificates (Fitness, Sickness, Refer, Death, X-ray,
                    Custom)
                  </li>
                  <li>Prescription view Facility for Dispensary Outlet</li>
                  <li>Various Summary Reports</li>
                  <li>User Access Rights for Multiple Users</li>
                  <li>Follow-up Patient List</li>
                  <li>SMS (Appointment, Patient Registration, Follow-up)</li>
                  <li>Patient Registration File Printing Label</li>
                  <li>Multiple Case Reports Formats</li>
                  <li>Single Database in LAN</li>
                  <li>Export Summary Reports in Excel</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ==========================================Model==================
         */}

        {isModalOpen && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={this.closeModal}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                width: "400px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4>Book Your Free Demo Here</h4>

              <form onSubmit={this.handleSubmit}>
                <div className="mt-3">
                  <label htmlFor="firstName">First Name:</label>
                  <input
                    type="text"
                    name="fname"
                    value={fname}
                    onChange={this.handleChange}
                    placeholder="first name"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="lastName">Last Name:</label>
                  <input
                    name="lname"
                    type="text"
                    value={lname}
                    onChange={this.handleChange}
                    placeholder="last name"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="email">Mobile No.:</label>
                  <input
                    name="email"
                    // type="email"
                    value={email}
                    onChange={this.handleChange}
                    placeholder="mobile no."
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                {/* <div className="mt-3">
                  <label htmlFor="subject">Subject:</label>
                  <input
                    name="subject"
                    type="text"
                    value={subject} // This will now show the static value
                    onChange={this.handleChange}
                    placeholder="subject"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div> */}

                <div
                  className="button-group"
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    type="button"
                    onClick={this.closeModal}
                    style={{
                      margin: "0 6px",
                      padding: "10px 20px",
                      backgroundColor: "#3498db",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2980b9";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3498db";
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    style={{
                      margin: "0 6px",
                      padding: "10px 20px",
                      backgroundColor: "#3498db",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2980b9"; // Change background color on hover
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3498db"; // Reset background when mouse leaves
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default OpdClinicSoftware;
